"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["PAID"] = "Paid";
    InvoiceStatus["UNPAID"] = "Unpaid";
    InvoiceStatus["OVERDUE"] = "Overdue";
    InvoiceStatus["CANCELLED"] = "Cancelled";
    InvoiceStatus["ACTIVE"] = "Active";
    InvoiceStatus["INPROGRESS"] = "Cancellation in progress";
})(InvoiceStatus = exports.InvoiceStatus || (exports.InvoiceStatus = {}));
var InvoiceKeys;
(function (InvoiceKeys) {
    InvoiceKeys["DUE_NOW"] = "DUE-NOW";
    InvoiceKeys["PAYMENT_HISTORY"] = "PAYMENT-HISTORY";
})(InvoiceKeys = exports.InvoiceKeys || (exports.InvoiceKeys = {}));
var InvoiceNumberPrefix;
(function (InvoiceNumberPrefix) {
    InvoiceNumberPrefix["TEMP"] = "TMP-INV";
})(InvoiceNumberPrefix = exports.InvoiceNumberPrefix || (exports.InvoiceNumberPrefix = {}));
var PaymentOptions;
(function (PaymentOptions) {
    PaymentOptions["ACH_OR_WIRE"] = "ACH/Wire";
    PaymentOptions["CREDIT_OR_DEBIT_CARD"] = "Credit/Debit Card";
    PaymentOptions["CHECK"] = "Check";
    PaymentOptions["PAY_WITH_ECKOH"] = "Pay with Eckoh";
    PaymentOptions["WIRE_CHECK"] = "Wire/Check";
    PaymentOptions["PAYPAL"] = "Paypal";
    PaymentOptions["ECKOH"] = "Eckoh";
    PaymentOptions["OFFLINE"] = "Offline";
    PaymentOptions["BANK_TRANSFER_CHEQUE"] = "Bank Transfer/Cheque";
    PaymentOptions["BANK_TRANSFER"] = "Bank transfer";
    PaymentOptions["ACH"] = "ACH";
    PaymentOptions["DIRECT_DEBIT"] = "DirectDebit";
    PaymentOptions["CREDIT_CARD"] = "CreditCard";
})(PaymentOptions = exports.PaymentOptions || (exports.PaymentOptions = {}));
var PaymentAmountOptions;
(function (PaymentAmountOptions) {
    PaymentAmountOptions["FULL_PAYMENT"] = "Full Payment";
    PaymentAmountOptions["PARTIAL_PAYMENT"] = "Partial Payment";
})(PaymentAmountOptions = exports.PaymentAmountOptions || (exports.PaymentAmountOptions = {}));
var InvoiceCheckoutStep;
(function (InvoiceCheckoutStep) {
    InvoiceCheckoutStep["PAYMENT_OPTIONS"] = "Payment Options";
    InvoiceCheckoutStep["PAYMENT"] = "Payment";
})(InvoiceCheckoutStep = exports.InvoiceCheckoutStep || (exports.InvoiceCheckoutStep = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PROCESSED"] = "Processed";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
var InstallmentTerm;
(function (InstallmentTerm) {
    InstallmentTerm["ONE_TIME"] = "One-time";
    InstallmentTerm["MONTHLY"] = "Monthly";
    InstallmentTerm["QUARTERLY"] = "Quarterly";
})(InstallmentTerm = exports.InstallmentTerm || (exports.InstallmentTerm = {}));
var SBX4InvoicePattern;
(function (SBX4InvoicePattern) {
    SBX4InvoicePattern["AICPA"] = "INV3, INV4, INV5, INV6";
    SBX4InvoicePattern["CIMA"] = "INV7, INV8, INV9";
})(SBX4InvoicePattern = exports.SBX4InvoicePattern || (exports.SBX4InvoicePattern = {}));
//# sourceMappingURL=index.js.map